import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';

type VerifyOrganizationTokenResponse = {
  valid: boolean;
};

const fetcher = async (url: string): Promise<VerifyOrganizationTokenResponse> =>
  await denApi.get<VerifyOrganizationTokenResponse, void>(url);

export function useVerifyOrganizationCreateToken(
  token: string | null,
  swrOptions?: SWRConfiguration<VerifyOrganizationTokenResponse>
) {
  const url = token ? `organization/create/verify/${token}` : null;

  const { data, error, isLoading, mutate } =
    useSWR<VerifyOrganizationTokenResponse>(url, fetcher, {
      revalidateOnFocus: false,
      ...(swrOptions ?? {}),
    });

  return {
    valid: data?.valid ?? false,
    isLoading,
    error,
    refresh: mutate,
    url,
    data,
  };
}
